"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketListStates = exports.TicketActions = void 0;
exports.TicketActions = new Set([
    'chat',
    'close',
    'approve',
    'decline',
    'auto_approve',
    'auto_decline',
    'reopen',
    'flag',
    'fasttrack',
    'escalate',
    'forms',
    'survey',
]);
var TicketListStates;
(function (TicketListStates) {
    TicketListStates["Open"] = "open";
    TicketListStates["Closed"] = "closed";
    TicketListStates["Approval"] = "approval";
})(TicketListStates = exports.TicketListStates || (exports.TicketListStates = {}));
